/**
 * @desc 订单提交(支持批量)
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/submitBatchOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
